import {
  FILTER_TYPES,
  ReportFilterConfigBase,
} from "../../filters/config/types";
import { dateRangePickerFields } from "../../filters/components/DateRangePicker";
import { ProjectAction, ProjectActionLabel } from "./types";

export const Filters: ReportFilterConfigBase[] = [
  {
    label: "Project",
    fields: "job_name_or_number",
    type: FILTER_TYPES.Query,
    fetchReportOnEnterPress: true,
    flexBasis: 228,
    containerStyle: {
      minWidth: "228px",
    },
  },
  {
    label: "Date Created",
    type: FILTER_TYPES.DateRange,
    fields: dateRangePickerFields,
    defaultValue: ["last_ytd", "", ""],
    presets: [
      {
        name: "last_ytd",
        label: "Last Year To Date",
      },
      {
        name: "last_year",
        label: "Last Year",
      },
      {
        name: "previous_quarter",
        label: "Last Quarter",
      },
      {
        name: "last_month",
        label: "Last Month",
      },
    ],
  },
  {
    label: "Client Rep",
    type: FILTER_TYPES.User,
    fields: [
      "client_rep_id",
      "client_rep_team_id",
      "include_inactive_client_reps",
    ],
  },
  {
    label: "Order Rep",
    type: FILTER_TYPES.User,
    fields: [
      "sales_rep_id",
      "sales_rep_team_id",
      "include_inactive_order_reps",
    ],
  },
  {
    label: "Order Status",
    type: FILTER_TYPES.OrderStatus,
    fields: "status_id",
    dependsOn: {
      filterFields: ["form_type"],
    },
  },
  {
    label: "Client",
    type: FILTER_TYPES.Client,
    fields: "client_id",
    flexBasis: 200,
    containerStyle: {
      minWidth: "200px",
    },
  },
  {
    label: "Min Budget",
    fields: "min_budget",
    type: FILTER_TYPES.Money,
    fetchReportOnEnterPress: true,
    flexBasis: 150,
    containerStyle: {
      minWidth: "150px",
    },
  },
  {
    label: "Action Taken",
    type: FILTER_TYPES.Dropdown,
    fields: "action_taken",
    options: [
      { value: "", label: "Any" },
      { value: ProjectAction.CREATE_TASK, label: ProjectActionLabel[ProjectAction.CREATE_TASK] },
      { value: ProjectAction.CREATE_PROJECT, label: ProjectActionLabel[ProjectAction.CREATE_PROJECT] },
      { value: ProjectAction.COPY_PRESENTATION, label: ProjectActionLabel[ProjectAction.COPY_PRESENTATION] },
      { value: ProjectAction.COPY_SALES_ORDER, label: ProjectActionLabel[ProjectAction.COPY_SALES_ORDER] },
      { value: "none", label: "None" },
    ],
    flexBasis: 150,
    containerStyle: {
      minWidth: "150px",
    },
  },
  {
    label: "Dismissed",
    type: FILTER_TYPES.Switch,
    defaultValue: "false",
    options: [
      { label: "Show", value: "false" },
      { label: "Hide", value: "true" },
    ],
    fields: "hide_dismissed",
    flexBasis: 150,
    containerStyle: {
      minWidth: "150px",
    },
  },
  {
    label: "Industry",
    type: FILTER_TYPES.Industry,
    fields: "industry_id",
  },
  {
    label: "Client Tags",
    type: FILTER_TYPES.ClientTag,
    fields: "client_tag",
  },
  {
    label: "Form",
    type: FILTER_TYPES.FormType,
    fields: "form_type",
  },
];
